import { useQuery } from "react-query";
import { getDepressionScreening } from "api/customers";

const useGetDepressionScreening = (clientId: number | null) => {
  const { data, isLoading, isError, refetch } = useQuery(
    ["getDepressionScreening", clientId],
    () => getDepressionScreening(clientId!),
    {
      enabled: !!clientId,
      refetchOnWindowFocus: false,
      retry: 1,
    }
  );

  return {
    depressionScreening: data?.data || null,
    isDepressionScreeningLoading: isLoading,
    isDepressionScreeningError: isError,
    refetchDepressionScreening: refetch,
  };
};

export default useGetDepressionScreening;
